import { IconContainer } from './ResendIdRequest.style';
import { Typography } from '@interstate/components/Typography';
import { getResendIdRequestState } from '../../shared/utils';
import { ResendIdRequestStatus } from '../../shared/types';
import { QuestionMarkCircleIcon } from '@interstate/components/Icons/QuestionMarkCircleIcon';
import { ClockIcon } from '@interstate/components/Icons/ClockIcon';
import { CheckCircleIcon } from '@interstate/components/Icons/CheckCircleIcon';
import type { InterstateTheme } from '@interstate/components/InterstateThemeProvider';
import { useInterstateTheme } from '@interstate/components/InterstateThemeProvider';

export interface ResendIdStatusProps {
    status: string;
    trustValue: string;
}

const resendStatusConfig = (theme: InterstateTheme) => ({
    [ResendIdRequestStatus.NotRequested]: {
        icon: QuestionMarkCircleIcon,
        color: theme.tokens.BaseColorBlue700,
        testId: 'question-mark-icon'
    },
    [ResendIdRequestStatus.Started]: {
        icon: ClockIcon,
        color: theme.tokens.BaseColorBlue500,
        testId: 'clock-icon'
    },
    [ResendIdRequestStatus.Completed]: {
        icon: CheckCircleIcon,
        color: theme.tokens.BaseColorGreen500,
        testId: 'check-circle-icon'
    }
});

export const ResendIdStatus = ({ status, trustValue }: ResendIdStatusProps) => {
    const theme = useInterstateTheme();
    const { resendStatus } = getResendIdRequestState(status, trustValue);
    const config = resendStatusConfig(theme)[resendStatus];
    const IconComponent = config.icon;
    const iconColor = config.color;
    const testId = config.testId;
    return (
        <IconContainer>
            <IconComponent data-testid={testId} color={iconColor} />
            <Typography variant="body-sm">{resendStatus}</Typography>
        </IconContainer>
    );
};
